module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"col-sm-6 col-sm-offset-3 col-xs-12 text-center\"> <div class=\"text-uppercase\"><h5>Balance</h5></div> <div class=\"balance\">")
    ; __append(escapeFn( locals.balance ))
    ; __append("</div> <h5>Plan: <strong class=\"price_per_shipment\">")
    ; __append(escapeFn( locals.price_per_shipment ))
    ; __append(" cents/label</strong></h5> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/account_balance.ejs
// module id = 820
// module chunks = 1